.page-up {
  position: fixed;
  bottom: 1rem;
  right: 1rem;

  &__btn {
    display: flex !important;
    width: 2.5rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    color: var(--tg-theme-button-text-color) !important;
    border-radius: 100% !important;
    background-color: var(--tg-theme-button-color) !important;

    &:hover {
      opacity: 0.8;
    }
  }
}
